export default __webpack_public_path__ + "static/outsidesettingwall-eba873741ef2ea9d033bccd31f3cc138.png";